import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import { Text } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { messages } from '@databases/intl/messages';
import React, { type FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

import AbstractLink from './AbstractLink.tsx';

export interface BrokenLinkProps {
  message?: string;
}

const BrokenLink: FunctionComponent<BrokenLinkProps> = ({ message }) => {
  const { formatMessage } = useIntl();

  return (
    <AbstractLink
      iconBefore={<StatusErrorIcon color={token('color.icon.danger')} label="" />}
    >
      <Text color={'color.text.danger'}>
        {message ?? formatMessage(messages['broken-link.broken-link-text'])}
      </Text>
    </AbstractLink>
  );
};

export default BrokenLink;
